module.exports = __webpack_public_path__ + "img/START.7046c737.svg";